import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=6a184f81&scoped=true&"
import script from "./AlertMessage.vue?vue&type=script&lang=js&"
export * from "./AlertMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a184f81",
  null
  
)

export default component.exports